import { formatarDataServidor } from "utils/date";

const createResult = (isValid, errorMessage) => ({
  isValid,
  errorMessage: isValid ? "" : errorMessage,
});

export const required = (value) => {
  return createResult(!!value, "Campo Obrigatório");
};

export const optionRequired = (value) => () => {
  return createResult(!!value, "Opção inválida");
};

export const customValue = (value, errorMessage) => () => {
  return createResult(!!value, errorMessage);
};

export const validOption = (options) => (value) => {
  return createResult(options.includes(value), "Opção inválida");
};

export const cpf = (strCPF) => {
  const createCpfResult = (isValid) => {
    return createResult(isValid, "Você deve informar um CPF válido.");
  };

  if (strCPF.length > 11) {
    return createCpfResult(false);
  }

  let Soma;
  let Resto;
  Soma = 0;
  if (
    strCPF === "00000000000" ||
    strCPF === "11111111111" ||
    strCPF === "22222222222" ||
    strCPF === "33333333333" ||
    strCPF === "44444444444" ||
    strCPF === "55555555555" ||
    strCPF === "66666666666" ||
    strCPF === "77777777777" ||
    strCPF === "88888888888" ||
    strCPF === "99999999999"
  ) {
    return createCpfResult(false);
  }

  for (let i = 1; i <= 9; i++) {
    Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (11 - i);
  }
  Resto = (Soma * 10) % 11;

  if (Resto === 10 || Resto === 11) {
    Resto = 0;
  }
  if (Resto !== parseInt(strCPF.substring(9, 10))) {
    return createCpfResult(false);
  }

  Soma = 0;
  for (let i = 1; i <= 10; i++) {
    Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (12 - i);
  }
  Resto = (Soma * 10) % 11;

  if (Resto === 10 || Resto === 11) {
    Resto = 0;
  }
  return createCpfResult(Resto === parseInt(strCPF.substring(10, 11)));
};

function validateDate(data) {
  const dtArray = data.split("/");

  if (dtArray === null) return false;

  const dtDay = dtArray[0];
  const dtMonth = dtArray[1];
  const dtYear = dtArray[2];

  if (dtMonth < 1 || dtMonth > 12) return false;
  else if (dtDay < 1 || dtDay > 31) return false;
  else if ((dtMonth === 4 || dtMonth === 6 || dtMonth === 9 || dtMonth === 11) && dtDay === 31)
    return false;
  else if (dtMonth === 2) {
    const isleap = dtYear % 4 === 0 && (dtYear % 100 !== 0 || dtYear % 400 === 0);
    if (dtDay > 29 || (dtDay === 29 && !isleap)) return false;
  }
  return true;
}
export const validBirthdate = (value) => {
  const minimumAge = 16;
  const createBirthdateResult = (isValid) => {
    return createResult(
      isValid,
      `Você deve informar uma data válida e acima de ${minimumAge} anos.`
    );
  };

  if (value.length < 8) {
    return createBirthdateResult(false);
  }

  const isDataValida = validateDate(value);
  if (!isDataValida) {
    return createBirthdateResult(false);
  }

  const anoAtual = new Date().getFullYear();
  const mesAtual = new Date().getMonth();
  const diaAtual = new Date().getDate();
  const dataLimite = new Date(anoAtual - minimumAge, mesAtual, diaAtual).toISOString().slice(0, 10);

  if (new Date(formatarDataServidor(value)) > new Date(dataLimite)) {
    return createBirthdateResult(false);
  }

  const ano = value.split("/")[2];

  return createResult(Number(ano) >= 1900, "Ano não pode ser inferior a 1900");
};

export const validEmail = (value) => {
  const createEmailResult = (isValid) => {
    return createResult(isValid, "Você deve informar um e-mail válido.");
  };

  const email = value.trim();
  const regex = /(^\w.*@[\w-]+\.\w)/; //NOSONAR: Executa no front.

  return createEmailResult(!!regex.test(email));
};

export const validPhone = (value) => {
  const createPhoneResult = (isValid) => {
    return createResult(isValid, "Você deve informar um telefone válido.");
  };

  if (value.length < 10) {
    return createPhoneResult(false);
  }

  return createPhoneResult(true);
};

export const validCellPhone = (value) => {
  const createPhoneResult = (isValid) => {
    return createResult(isValid, "Você deve informar um celular válido.");
  };

  if (value.length < 11) {
    return createPhoneResult(false);
  }

  return createPhoneResult(true);
};

export const validOptionalPhone = (value) => {
  if (!value) {
    return createResult(true, "");
  }
  return validPhone(value);
};
